import svgxhr from 'webpack-svgstore-plugin/src/helpers/svgxhr';

// eslint-disable-next-line
const __svg__ = {
  path: './media/img/svg/*.svg',
  name: 'sprite-store.svg',
};

svgxhr(__svg__);
